// ─────────────────────────────────────────────────────────────────────────
// Romania Destination Hub — single source of truth for the hub experience.
// Reuses the existing hotel database (hotels.romania.ts) and layers on the
// editorial metadata the hub needs: region introductions, luxury experiences,
// curated itineraries, the gallery and travel-inspiration content.
// ─────────────────────────────────────────────────────────────────────────
import { romaniaHotels, RomaniaHotel, ravensNestPhotos, sadovaVillagePhotos, telefericGrandHotelPhotos, marmoroschPhotos, pineLodgeBucegiPhotos, szeklerEstatePhotos } from './hotels.romania';





export type { RomaniaHotel } from './hotels.romania';
export { romaniaHotels } from './hotels.romania';

// Shared imagery pool (existing hotel imagery + new editorial shots).
export const HUB_IMG = {
  heroA: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750891066_db9afbe4.jpg',
  heroB: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750927714_cde75fbc.png',
  bran: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782406694217_33fd396b.png',
  // ── Sighișoara City (uploaded photos) ──
  sighisoaraA: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783533349713_eee1e46d.jpeg',
  sighisoaraB: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1783533410248_11686c11.webp',
  sighisoaraC: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783533350643_a0a80bc5.jpeg',
  delta: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782757844096_10387d6c.jpeg',
  pelesA: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783007194816_a7846016.jpeg',
  pelesB: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783007195397_b60a6269.jpeg',
  bucharest: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782757619537_b56bf942.jpeg',
  bucharest2: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782757620909_5d17adea.jpeg',
  deltaResort: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782757844672_fe2697fb.jpeg',
  brasovOldTown: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1783697595494_7f67a60c.jpg',
  // ── Breb / Maramureș (uploaded photos) ──
  brebHaystacks: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782758383583_b17f7356.jpeg',
  brebFolkCouple: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782758384111_32ec196d.jpeg',
  brebPotter: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782758384305_8bb6f1b6.jpeg',
  brebPotter2: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782758384487_862ec0a5.jpeg',
  brebTrainSheep: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782758384779_770be62d.jpeg',
  brebTrainCart: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782758384955_ba152fc8.jpeg',
  brebTrainRock: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782758385365_dce89692.jpeg',
  brebChurchInterior: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782758385541_61fb3c7f.jpeg',
  brebBarsana: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782758385790_bd51443c.png',
  brebChurchSpire: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782758386008_da9fafe3.jpeg',
  brebMerryCemetery: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782758386227_c2bd9a1d.jpeg',
  brebCottage: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782758386383_abffce62.jpeg',
  brebCarolers: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782758386628_a2271ae4.jpeg',
  brebFolkDance: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782758386867_fa03599d.jpeg',
  brebRiders: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782758387139_99784fa6.jpeg',
  brebWhiteCottage: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782758387355_d299c21a.jpeg',
  brebVillage: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782758387575_a67c67b8.jpeg',
  chalet: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750093311_f75b0da5.png',
  chalet2: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750098883_210354fd.png',
  estate: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750119475_9d0ce4a4.png',
  estate2: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750117498_aae8d147.jpg',
  saxon: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750147082_9f17f4e9.png',
  saxon2: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750150552_61940410.jpg',
  farm: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750170558_d59ed0fc.jpg',
  bucov: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750198153_6f681445.jpg',
  bucov2: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750196220_6f148354.jpg',
  bioFarm: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750216458_88526544.jpg',
  castle: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750248825_cbeefd4a.png',
  castle2: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750248001_d540bf24.jpg',
};

export const BOOKING_LINK = '/romania/booking';

// ── Hotel classification ────────────────────────────────────────────────
// Layer a hotel "type" and "luxury level" onto each hotel for the filterable
// Featured Hotels collection, without duplicating the hotel records.
export type HotelType =
  | 'Castle Hotels'
  | 'Spa Resorts'
  | 'Mountain Lodges'
  | 'Boutique Hotels'
  | 'Countryside Estates'
  | 'River Resorts';

export const HOTEL_TYPES: HotelType[] = [
  'Castle Hotels',
  'Spa Resorts',
  'Mountain Lodges',
  'Boutique Hotels',
  'Countryside Estates',
  'River Resorts',
];

// Map hotel id -> { type, luxury (1-5), amenities }
const HOTEL_META: Record<number, { type: HotelType; luxury: number; amenities: string[] }> = {
  101: { type: 'Boutique Hotels', luxury: 5, amenities: ['Spa', 'Fine Dining', 'Concierge', 'City Centre'] },
  102: { type: 'Boutique Hotels', luxury: 5, amenities: ['Heritage', 'Fine Dining', 'Bar', 'Concierge'] },
  103: { type: 'Boutique Hotels', luxury: 5, amenities: ['Rooftop Bar', 'Art Deco', 'Spa', 'Old Town'] },
  201: { type: 'River Resorts', luxury: 5, amenities: ['Spa', 'Boat Safaris', 'Waterfront', 'Fine Dining'] },
  202: { type: 'River Resorts', luxury: 3, amenities: ['Eco Villas', 'Birdwatching', 'Beach', 'Boating'] },
  301: { type: 'Boutique Hotels', luxury: 5, amenities: ['Relais & Châteaux', 'Locavore', 'Design', 'Mountain Views'] },
  302: { type: 'Spa Resorts', luxury: 4, amenities: ['Winery', 'Spa', 'Wellness', 'Vineyards'] },
  303: { type: 'Castle Hotels', luxury: 5, amenities: ['Renaissance Castle', 'Antiques', 'Courtyards', 'Fine Dining'] },
  304: { type: 'Mountain Lodges', luxury: 4, amenities: ['Alpine', 'Fireplaces', 'Hiking', 'Skiing'] },
  305: { type: 'Mountain Lodges', luxury: 4, amenities: ['Ski-in', 'Modern', 'Spa', 'Cable Car Access'] },
  306: { type: 'Spa Resorts', luxury: 5, amenities: ['Spa', 'Fine Dining', 'Forest Views', 'Ski Access'] },
  307: { type: 'Boutique Hotels', luxury: 3, amenities: ['Citadel Views', 'Boutique', 'Central', 'Cosy'] },
  308: { type: 'Mountain Lodges', luxury: 5, amenities: ['Designer Chalet', 'Panoramic Views', 'Seclusion', 'Near Bran'] },
  309: { type: 'Mountain Lodges', luxury: 4, amenities: ['Spa', 'Pool', 'Terraces', 'Carpathian Views'] },
  401: { type: 'Countryside Estates', luxury: 5, amenities: ['Private Estate', 'Wildlife', 'History', 'Forest Reserve'] },
  402: { type: 'Spa Resorts', luxury: 4, amenities: ['Thermal Spa', 'Mineral Springs', 'Pools', 'Trails'] },
  403: { type: 'Countryside Estates', luxury: 4, amenities: ['Farm-to-Table', 'Village Life', 'Meadow Views', 'Tranquil'] },
  404: { type: 'Countryside Estates', luxury: 5, amenities: ['Noble Houses', 'Heritage', 'Saxon Village', 'Slow Living'] },
  405: { type: 'Castle Hotels', luxury: 5, amenities: ['Renaissance Castle', 'Vineyards', 'Cellar Tastings', 'Gardens'] },
  406: { type: 'Spa Resorts', luxury: 4, amenities: ['Spa', 'Wellness', 'Hills', 'Modern Comfort'] },
  407: { type: 'Mountain Lodges', luxury: 5, amenities: ['Off-grid', 'Romantic', 'Apuseni Views', 'Restored Cottages'] },
  501: { type: 'Countryside Estates', luxury: 4, amenities: ['Saxon Farmstead', 'Slow Food', 'UNESCO Village', 'Courtyards'] },
  502: { type: 'Boutique Hotels', luxury: 4, amenities: ['Heritage', 'Saxon Architecture', 'Tranquil', 'Craft Workshops'] },
  503: { type: 'Boutique Hotels', luxury: 4, amenities: ['Garden', 'Local Dining', 'Restored Charm', 'Serene'] },
  504: { type: 'Countryside Estates', luxury: 3, amenities: ['Rustic-Chic', 'Courtyard', 'Home Cooking', 'Near Church'] },
  505: { type: 'Countryside Estates', luxury: 3, amenities: ['Saxon Guesthouse', 'Countryside', 'Fortified Churches', 'Authentic'] },
  601: { type: 'Mountain Lodges', luxury: 4, amenities: ['Carved Wood', 'Mountain Views', 'Boutique', 'Village'] },
  602: { type: 'Countryside Estates', luxury: 3, amenities: ['Family-Run', 'Orchards', 'Home Cooking', 'Wooden Churches'] },
  603: { type: 'Countryside Estates', luxury: 3, amenities: ['Folk Traditions', 'Carved Gates', 'Comfortable Rooms', 'Authentic'] },
  701: { type: 'Mountain Lodges', luxury: 4, amenities: ['Organic', 'Farm-to-Table', 'Nature Trails', 'Near Monastery'] },
  702: { type: 'Countryside Estates', luxury: 4, amenities: ['Heritage', 'Restaurant', 'Elegant Rooms', 'Near Monasteries'] },
  703: { type: 'Mountain Lodges', luxury: 4, amenities: ['Design Chalet', 'Forest Views', 'Modern', 'Near Voroneț'] },
  704: { type: 'Mountain Lodges', luxury: 4, amenities: ['Alpine', 'Hiking', 'Stargazing', 'Seclusion'] },
  705: { type: 'Countryside Estates', luxury: 3, amenities: ['Traditional', 'Local Cuisine', 'Hospitality', 'Near Voroneț'] },
  706: { type: 'Mountain Lodges', luxury: 3, amenities: ['Village Resort', 'Spruce Forests', 'Restful', 'Monastery Tours'] },
  707: { type: 'Countryside Estates', luxury: 4, amenities: ['Organic Farm', 'Pastures', 'Rustic-Luxe', 'Homegrown Food'] },
};

export interface EnrichedHotel extends RomaniaHotel {
  type: HotelType;
  luxury: number;
  amenities: string[];
}

export const enrichedHotels: EnrichedHotel[] = romaniaHotels.map((h) => {
  const meta = HOTEL_META[h.id] ?? {
    type: 'Boutique Hotels' as HotelType,
    luxury: 3,
    amenities: ['Comfort', 'Hospitality'],
  };
  return { ...h, ...meta };
});

// ── Region editorial content ────────────────────────────────────────────
export interface HubRegion {
  id: string;
  name: string;
  // which hotel regions feed this region's recommended stays
  hotelRegions: string[];
  image: string;
  imageAlt: string;
  intro: string;
  topExperiences: string[];
  mustSee: string[];
  stay: string;
  season: string;
}

export const hubRegions: HubRegion[] = [
  {
    id: 'bucharest',
    name: 'Bucharest',
    hotelRegions: ['Bucharest'],
    image: HUB_IMG.bucharest,
    imageAlt: 'Belle Époque architecture in central Bucharest, Romania.',
    intro:
      'Once known as “Little Paris,” Bucharest is a city of grand boulevards, Belle Époque palaces and an electric contemporary spirit. Beneath the colossal Palace of the Parliament lie hidden courtyards, leafy parks and a buzzing Old Town of wine bars and ateliers.',
    topExperiences: ['Private architecture walk', 'Palace of the Parliament tour', 'Old Town wine evening', 'Calea Victoriei boutiques'],
    mustSee: ['Romanian Athenaeum', 'Stavropoleos Monastery', 'Cișmigiu Gardens', 'Village Museum'],
    stay: '2–3 days',
    season: 'April – October',
  },
  {
    id: 'danube-delta',
    name: 'Danube Delta',
    hotelRegions: ['Danube Delta'],
    image: HUB_IMG.delta,
    imageAlt: 'Reed channels of the Danube Delta at dawn, Romania.',
    intro:
      'Europe’s largest and best-preserved wetland, the UNESCO Danube Delta is a labyrinth of reed channels, floating villages and golden lagoons. Glide past pelican colonies and 300 bird species aboard a private skiff into one of the continent’s last great wildernesses.',
    topExperiences: ['Private boat safari', 'Sunrise birdwatching', 'Lipovan fishing village visit', 'Wild Black Sea beach picnic'],
    mustSee: ['Letea Forest', 'Sfântu Gheorghe', 'Pelican colonies', 'Mila 23'],
    stay: '2–3 days',
    season: 'May – September',
  },
  {
    id: 'brasov',
    name: 'Brașov',
    hotelRegions: ['Brașov'],
    image: HUB_IMG.brasovOldTown,
    imageAlt: 'Brașov Old Town and its medieval Council Square beneath the Carpathian mountains, Romania.',
    intro:
      'Cradled by the Carpathians, medieval Brașov pairs Gothic spires and a storybook square with easy reach of mountain resorts, castles and ski slopes. It is the perfect base for exploring Transylvania’s most legendary landmarks.',
    topExperiences: ['Council Square stroll', 'Cable car to Tâmpa', 'Poiana Brașov skiing', 'Carpathian hiking'],
    mustSee: ['Black Church', 'Rope Street', 'Council Square', 'Tâmpa Mountain'],
    stay: '2–4 days',
    season: 'Year-round',
  },
  {
    id: 'castles',
    name: 'Castles of Romania',
    hotelRegions: ['Brașov', 'Carpathians & Transylvania'],
    image: HUB_IMG.pelesA,
    imageAlt: 'Peleș Castle surrounded by Carpathian forest, Romania.',
    intro:
      'From Dracula’s clifftop Bran to the fairytale spires of Peleș and the Renaissance halls of Bethlen Haller, Romania’s castles are the stage for an unforgettable journey. Sleep within restored noble walls and trace centuries of Transylvanian legend.',
    topExperiences: ['Bran Castle by private guide', 'Peleș & Pelișor tour', 'Castle-hotel overnight', 'Corvin Castle excursion'],
    mustSee: ['Bran Castle', 'Peleș Castle', 'Corvin Castle', 'Bethlen Haller Castle'],
    stay: '3–5 days',
    season: 'April – October',
  },
  {
    id: 'carpathians',
    name: 'Carpathian Mountains',
    hotelRegions: ['Carpathians & Transylvania', 'Bucovina'],
    image: HUB_IMG.chalet2,
    imageAlt: 'Forested Carpathian peaks in Transylvania, Romania.',
    intro:
      'The wild green heart of Europe, the Carpathians shelter the continent’s largest population of brown bears, ancient virgin forests and shepherding traditions unchanged for centuries. Trade the crowds for alpine silence, thermal springs and panoramic ridgelines.',
    topExperiences: ['Brown-bear watching', 'Transfăgărășan drive', 'Alpine spa & wellness', 'Guided summit hikes'],
    mustSee: ['Transfăgărășan Road', 'Bâlea Lake', 'Piatra Craiului', 'Apuseni caves'],
    stay: '3–5 days',
    season: 'June – September',
  },
  {
    id: 'transylvania',
    name: 'Transylvania',
    hotelRegions: ['Carpathians & Transylvania', 'Sighișoara & Viscri'],
    image: HUB_IMG.estate,
    imageAlt: 'Rolling Transylvanian countryside with a noble estate, Romania.',
    intro:
      'Beyond the myths, Transylvania is a tapestry of Saxon villages, fortified churches and aristocratic estates set amid wildflower meadows. This is slow, soulful travel — farm-to-table dinners, horse-drawn carts and the gentle rhythm of rural life.',
    topExperiences: ['Saxon village immersion', 'Fortified church trail', 'Private estate stay', 'Sibiu old-town tour'],
    mustSee: ['Sibiu', 'Biertan church', 'Zabola Estate', 'Mărginimea Sibiului'],
    stay: '4–6 days',
    season: 'May – October',
  },
  {
    id: 'sighisoara',
    name: 'Sighișoara',
    hotelRegions: ['Sighișoara & Viscri'],
    image: HUB_IMG.sighisoaraA,
    imageAlt: 'The Clock Tower of Sighișoara rising over the citadel square and its colourful medieval houses, Transylvania, Romania.',
    intro:
      'A jewel of medieval Europe, UNESCO-listed Sighișoara is a perfectly preserved citadel of pastel houses, guild towers and the birthplace of Vlad the Impaler. Wander cobbled lanes that have barely changed in five centuries.',
    topExperiences: ['Citadel walking tour', 'Clock Tower climb', 'Artisan workshops', 'Medieval dinner'],
    mustSee: ['Clock Tower', 'Church on the Hill', 'Covered Staircase', "Vlad Dracul House"],
    stay: '1–2 days',
    season: 'April – October',
  },
  {
    id: 'viscri',
    name: 'Viscri',
    hotelRegions: ['Sighișoara & Viscri'],
    image: HUB_IMG.saxon,
    imageAlt: 'Whitewashed Saxon houses and fortified church in Viscri, Romania.',
    intro:
      'Famously cherished by King Charles III, Viscri is a timeless Saxon hamlet of whitewashed cottages, a UNESCO fortified church and a slow-food ethic. Here, blacksmiths still work by hand and the meadows hum with wild bees.',
    topExperiences: ['Fortified church visit', 'Blacksmith & craft tour', 'Horse-cart through meadows', 'Slow-food farmhouse lunch'],
    mustSee: ['Fortified Church', 'Saxon farmsteads', 'Village workshops', 'Wildflower meadows'],
    stay: '1–2 days',
    season: 'May – September',
  },
  {
    id: 'maramures',
    name: 'Maramureș',
    hotelRegions: ['Maramureș'],
    image: HUB_IMG.brebCottage,
    imageAlt: 'Traditional wooden cottage in the storybook village of Breb, Maramureș, Romania.',
    intro:
      'A living open-air museum, Maramureș guards Romania’s most authentic rural soul — towering wooden churches, hand-carved gates and a way of life ruled by the seasons. The painted Merry Cemetery turns even death into folk poetry.',
    topExperiences: ['Wooden churches trail', 'Merry Cemetery visit', 'Folk craft workshops', 'Mocănița steam train'],
    mustSee: ['Merry Cemetery', 'Bârsana Monastery', 'Breb village', 'Mocănița railway'],
    stay: '2–3 days',
    season: 'May – October',
  },
  {
    id: 'bucovina',
    name: 'Bucovina',
    hotelRegions: ['Bucovina'],
    image: HUB_IMG.bucov,
    imageAlt: 'Painted monastery and green hills of Bucovina, Romania.',
    intro:
      'In Romania’s far north, Bucovina’s UNESCO painted monasteries glow with five-century-old frescoes set against rolling hills and spruce forests. It is a spiritual, soulful land of organic farms, hearty cuisine and gentle mountain quiet.',
    topExperiences: ['Painted monasteries tour', 'Organic farm dining', 'Carpathian forest walks', 'Pottery & egg-painting'],
    mustSee: ['Voroneț Monastery', 'Sucevița Monastery', 'Moldovița Monastery', 'Putna Monastery'],
    stay: '2–3 days',
    season: 'May – September',
  },
];

// ── Luxury experience collections ───────────────────────────────────────
export interface LuxuryExperience {
  id: string;
  title: string;
  image: string;
  imageAlt: string;
  description: string;
  highlights: string[];
  duration: string;
  level: string;
}

export const luxuryExperiences: LuxuryExperience[] = [
  {
    id: 'castle-collection',
    title: 'Luxury Castle Collection',
    image: HUB_IMG.castle,
    imageAlt: 'Restored Renaissance castle hotel in Transylvania, Romania.',
    description:
      'Sleep behind centuries-old castle walls on a curated circuit of Romania’s most romantic noble residences — from Dracula’s Bran to the vineyard-wrapped Bethlen Haller.',
    highlights: ['Private castle tours', 'Noble-house overnights', 'Cellar wine tastings', 'Heritage dining'],
    duration: '5 – 7 days',
    level: 'Signature Luxury',
  },
  {
    id: 'private-transylvania',
    title: 'Private Transylvania Journey',
    image: HUB_IMG.estate2,
    imageAlt: 'Private aristocratic estate amid Transylvanian meadows, Romania.',
    description:
      'A bespoke, chauffeured immersion through Saxon villages, fortified churches and aristocratic estates, with privileged access and a dedicated travel designer throughout.',
    highlights: ['Private guide & driver', 'Estate & manor stays', 'Saxon village access', 'Farm-to-table dinners'],
    duration: '6 – 8 days',
    level: 'Bespoke',
  },
  {
    id: 'countryside-escape',
    title: 'Romanian Countryside Escape',
    image: HUB_IMG.saxon2,
    imageAlt: 'Whitewashed Saxon farmhouse courtyard in rural Transylvania, Romania.',
    description:
      'Trade the itinerary for the rhythm of village life — horse-drawn carts, wildflower meadows and slow-food kitchens in Viscri, Breb and the hidden hamlets of Transylvania.',
    highlights: ['Slow-food farmhouse meals', 'Artisan & craft visits', 'Meadow walks', 'Authentic village stays'],
    duration: '4 – 6 days',
    level: 'Refined Rustic',
  },
  {
    id: 'mountain-adventure',
    title: 'Luxury Mountain Adventure',
    image: HUB_IMG.chalet2,
    imageAlt: 'Alpine designer chalet in the Carpathian mountains, Romania.',
    description:
      'Design-led chalets, alpine spas and private guides combine for active days in the Carpathians — hiking, the Transfăgărășan and brown-bear watching at dusk.',
    highlights: ['Designer mountain chalets', 'Private summit hikes', 'Transfăgărășan drive', 'Alpine spa & wellness'],
    duration: '5 – 7 days',
    level: 'Active Luxury',
  },
  {
    id: 'delta-expedition',
    title: 'Danube Delta Wildlife Expedition',
    image: HUB_IMG.deltaResort,
    imageAlt: 'Luxury waterfront resort among the reeds of the Danube Delta, Romania.',
    description:
      'A waterborne expedition into Europe’s greatest wetland — private skiffs, sunrise birdwatching and a luxury delta resort base among 300 bird species and golden lagoons.',
    highlights: ['Private boat safaris', 'Expert naturalist guide', 'Sunrise birdwatching', 'Delta spa resort'],
    duration: '3 – 4 days',
    level: 'Exclusive',
  },
  {
    id: 'hidden-villages',
    title: 'Hidden Villages of Romania',
    image: HUB_IMG.farm,
    imageAlt: 'Carved wooden gate and farmhouse in a Maramureș village, Romania.',
    description:
      'An off-the-map odyssey through Maramureș and Bucovina — wooden churches, painted monasteries and the carved-gate villages where folk tradition still rules the seasons.',
    highlights: ['Wooden churches trail', 'Painted monasteries', 'Folk craft workshops', 'Mocănița steam train'],
    duration: '5 – 7 days',
    level: 'Cultural Immersion',
  },
  {
    id: 'wine-culinary',
    title: 'Wine & Culinary Journey',
    image: HUB_IMG.estate,
    imageAlt: 'Vineyard estate and wine cellar in Transylvania, Romania.',
    description:
      'Romania’s renaissance of food and wine, from Bucharest’s bistronomy to vineyard estates and castle cellars — private tastings, chef’s tables and harvest-fresh markets.',
    highlights: ['Private vineyard tastings', 'Chef’s table dinners', 'Market & foraging tours', 'Castle-cellar pairings'],
    duration: '5 – 6 days',
    level: 'Gourmet',
  },
];

// ── Curated itineraries ─────────────────────────────────────────────────
export interface ItineraryDay {
  day: string;
  title: string;
  detail: string;
}
export interface Itinerary {
  id: string;
  title: string;
  duration: string;
  image: string;
  imageAlt: string;
  summary: string;
  regions: string[];
  days: ItineraryDay[];
}

export const itineraries: Itinerary[] = [
  {
    id: 'castles-brasov',
    title: '5-Day Castles & Brașov',
    duration: '5 Days',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1783701238857_fab8553e.jpg',
    imageAlt: 'Bran Castle rising above the Carpathian forest in Transylvania, Romania.',
    summary: 'Romania’s legendary castles paired with medieval Brașov and the Bucegi mountains.',
    regions: ['Bucharest', 'Brașov', 'Castles of Romania'],
    days: [
      { day: 'Day 1', title: 'Bucharest', detail: 'Arrival and an evening in the capital’s Old Town.' },
      { day: 'Day 2', title: 'Peleș & Sinaia', detail: 'Drive to the Carpathians for Peleș Castle and a mountain-hotel check-in.' },
      { day: 'Day 3', title: 'Bran & Râșnov', detail: 'Dracula’s Bran Castle and the Râșnov Citadel by private guide.' },
      { day: 'Day 4', title: 'Brașov', detail: 'Council Square, the Black Church and a cable car to Tâmpa.' },
      { day: 'Day 5', title: 'Departure', detail: 'Scenic transfer back to Bucharest for your flight.' },
    ],
  },

  {
    id: 'discover-transylvania',
    title: '7-Day Discover Transylvania',
    duration: '7 Days',
    image: HUB_IMG.estate2,
    imageAlt: 'Transylvanian estate among rolling meadows, Romania.',
    summary: 'Saxon villages, fortified churches and aristocratic estates across the Transylvanian heartland.',
    regions: ['Brașov', 'Sighișoara', 'Viscri', 'Transylvania'],
    days: [
      { day: 'Day 1', title: 'Bucharest → Brașov', detail: 'Arrival and transfer to medieval Brașov.' },
      { day: 'Day 2', title: 'Bran & Râșnov', detail: 'Castles, citadels and Carpathian views.' },
      { day: 'Day 3', title: 'Viscri', detail: 'Saxon village immersion and the UNESCO fortified church.' },
      { day: 'Day 4', title: 'Sighișoara', detail: 'The medieval citadel and artisan workshops.' },
      { day: 'Day 5', title: 'Sibiu', detail: 'Old-town squares and the Mărginimea Sibiului hills.' },
      { day: 'Day 6', title: 'Private Estate', detail: 'A noble estate stay with farm-to-table dining.' },
      { day: 'Day 7', title: 'Departure', detail: 'Transfer for your onward journey.' },
    ],
  },
  {
    id: 'luxury-romania',
    title: '10-Day Luxury Romania',
    duration: '10 Days',
    image: HUB_IMG.castle2,
    imageAlt: 'Luxury castle hotel and gardens in Romania.',
    summary: 'A signature grand tour of Romania’s castles, mountains, capital and Saxon heartland.',
    regions: ['Bucharest', 'Castles of Romania', 'Carpathian Mountains', 'Transylvania'],
    days: [
      { day: 'Day 1–2', title: 'Bucharest', detail: 'The capital’s architecture and gastronomy.' },
      { day: 'Day 3–4', title: 'Castles', detail: 'Peleș, Bran and a noble castle-hotel overnight.' },
      { day: 'Day 5–6', title: 'Carpathians', detail: 'Alpine chalets, the Transfăgărășan and bear watching.' },
      { day: 'Day 7–8', title: 'Transylvania', detail: 'Sibiu, Sighișoara and Saxon estates.' },
      { day: 'Day 9–10', title: 'Viscri & Return', detail: 'Slow-food village days before your transfer.' },
    ],
  },
  {
    id: 'ultimate-romania',
    title: '14-Day Ultimate Romania Experience',
    duration: '14 Days',
    image: HUB_IMG.heroB,
    imageAlt: 'Sweeping Carpathian landscape at golden hour, Romania.',
    summary: 'The definitive coast-to-mountains odyssey — capital, delta, castles, Carpathians, Transylvania, Maramureș and Bucovina.',
    regions: ['Bucharest', 'Danube Delta', 'Castles of Romania', 'Transylvania', 'Maramureș', 'Bucovina'],
    days: [
      { day: 'Day 1–2', title: 'Bucharest', detail: 'The vibrant capital.' },
      { day: 'Day 3–4', title: 'Danube Delta', detail: 'A wildlife expedition by private skiff.' },
      { day: 'Day 5–6', title: 'Castles & Brașov', detail: 'Bran, Peleș and medieval Brașov.' },
      { day: 'Day 7–8', title: 'Carpathians', detail: 'Alpine adventure and wellness.' },
      { day: 'Day 9–10', title: 'Transylvania', detail: 'Sibiu, Sighișoara and Viscri.' },
      { day: 'Day 11–12', title: 'Maramureș', detail: 'Wooden churches and the Merry Cemetery.' },
      { day: 'Day 13–14', title: 'Bucovina & Return', detail: 'Painted monasteries before your departure.' },
    ],
  },
];

// ── Destination gallery ─────────────────────────────────────────────────
export interface GalleryImage {
  src: string;
  alt: string;
  category: string;
}

// The Destination Gallery shows ONLY the photos that were actually uploaded
// for Romania, grouped by the real location they were taken in. As more
// location photo-sets are uploaded, add their HUB_IMG entries here under the
// matching location category.
export const galleryCategories = [
  'All',
  'Bucharest',
  'Danube Delta',
  'Brașov Old Town',
  'Breb / Maramureș',
  "Raven's Nest / Apuseni",
  'Sadova / Bucovina',
  'Sighișoara / Transylvania',
  'Teleferic / Poiana Brașov',
  'The Marmorosch / Bucharest',
  'The Pine Lodge / Bucegi',
  'The Szekler / Szeklerland',
];



export const galleryImages: GalleryImage[] = [
  // ── Bucharest (uploaded photos) ──
  { src: HUB_IMG.bucharest, alt: 'Bucharest, Romania.', category: 'Bucharest' },
  { src: HUB_IMG.bucharest2, alt: 'Bucharest, Romania.', category: 'Bucharest' },
  // ── Danube Delta (uploaded photos) ──
  { src: HUB_IMG.delta, alt: 'Danube Delta, Romania.', category: 'Danube Delta' },
  { src: HUB_IMG.deltaResort, alt: 'Danube Delta, Romania.', category: 'Danube Delta' },
  // ── Brașov Old Town (uploaded photos) ──
  { src: HUB_IMG.brasovOldTown, alt: 'Brașov Old Town and Council Square, Romania.', category: 'Brașov Old Town' },
  // ── Breb / Maramureș (uploaded photos) ──
  { src: HUB_IMG.brebHaystacks, alt: 'Hay meadows and haystacks at sunset in Breb, Maramureș, Romania.', category: 'Breb / Maramureș' },
  { src: HUB_IMG.brebFolkCouple, alt: 'A couple in traditional Maramureș folk costume in Breb, Romania.', category: 'Breb / Maramureș' },
  { src: HUB_IMG.brebPotter, alt: 'A local potter at work in his Maramureș studio near Breb, Romania.', category: 'Breb / Maramureș' },
  { src: HUB_IMG.brebPotter2, alt: 'A craftsman shaping clay in a traditional Maramureș pottery near Breb, Romania.', category: 'Breb / Maramureș' },
  { src: HUB_IMG.brebTrainSheep, alt: 'The Mocănița steam train passing grazing sheep in the Maramureș valley, Romania.', category: 'Breb / Maramureș' },
  { src: HUB_IMG.brebTrainCart, alt: 'A horse cart beside the Mocănița steam train in Maramureș, Romania.', category: 'Breb / Maramureș' },
  { src: HUB_IMG.brebTrainRock, alt: 'The Mocănița steam train winding through the Maramureș forest near Breb, Romania.', category: 'Breb / Maramureș' },
  { src: HUB_IMG.brebChurchInterior, alt: 'Painted interior of a wooden church in Maramureș, Romania.', category: 'Breb / Maramureș' },
  { src: HUB_IMG.brebBarsana, alt: 'The wooden spires of Bârsana Monastery in Maramureș, Romania.', category: 'Breb / Maramureș' },
  { src: HUB_IMG.brebChurchSpire, alt: 'A towering wooden church spire under a blue sky in Maramureș, Romania.', category: 'Breb / Maramureș' },
  { src: HUB_IMG.brebMerryCemetery, alt: 'The painted blue crosses of the Merry Cemetery in Maramureș, Romania.', category: 'Breb / Maramureș' },
  { src: HUB_IMG.brebCottage, alt: 'A traditional wooden cottage with blue windows in Breb, Maramureș, Romania.', category: 'Breb / Maramureș' },
  { src: HUB_IMG.brebCarolers, alt: 'Children in folk costume carolling in the winter snow in Maramureș, Romania.', category: 'Breb / Maramureș' },
  { src: HUB_IMG.brebFolkDance, alt: 'Villagers folk dancing in traditional dress in Maramureș, Romania.', category: 'Breb / Maramureș' },
  { src: HUB_IMG.brebRiders, alt: 'Horseback riders in folk costume during a Maramureș festival near Breb, Romania.', category: 'Breb / Maramureș' },
  { src: HUB_IMG.brebWhiteCottage, alt: 'A whitewashed traditional cottage with woven rugs in Breb, Maramureș, Romania.', category: 'Breb / Maramureș' },
  { src: HUB_IMG.brebVillage, alt: 'Sun rays over the village and church of Breb in the Maramureș hills, Romania.', category: 'Breb / Maramureș' },
  // ── Raven's Nest / Apuseni (uploaded photos) ──
  ...ravensNestPhotos.map((p) => ({ ...p, category: "Raven's Nest / Apuseni" })),
  // ── Sadova / Bucovina (uploaded photos) ──
  ...sadovaVillagePhotos.map((p) => ({ ...p, category: 'Sadova / Bucovina' })),
  // ── Sighișoara City (uploaded photos) ──
  { src: HUB_IMG.sighisoaraA, alt: 'The Clock Tower of Sighișoara rising over the citadel square and its colourful medieval houses, Transylvania, Romania.', category: 'Sighișoara / Transylvania' },
  { src: HUB_IMG.sighisoaraB, alt: 'Aerial view of the Sighișoara citadel, its orange rooftops and the Church on the Hill at sunrise, Transylvania, Romania.', category: 'Sighișoara / Transylvania' },
  { src: HUB_IMG.sighisoaraC, alt: 'Cobbled citadel square with pastel façades and a flower-basket bicycle in Sighișoara, Transylvania, Romania.', category: 'Sighișoara / Transylvania' },
  // ── Teleferic Grand Hotel (uploaded photos) ──
  ...telefericGrandHotelPhotos.map((p) => ({ ...p, category: 'Teleferic / Poiana Brașov' })),
  // ── The Marmorosch, Autograph Collection (uploaded photos) ──
  ...marmoroschPhotos.map((p) => ({ ...p, category: 'The Marmorosch / Bucharest' })),
  // ── The Pine Lodge Bucegi (uploaded photos) ──
  ...pineLodgeBucegiPhotos.map((p) => ({ ...p, category: 'The Pine Lodge / Bucegi' })),
  // ── The Szekler — Transylvania Countryside Estate (uploaded photos) ──
  ...szeklerEstatePhotos.map((p) => ({ ...p, category: 'The Szekler / Szeklerland' })),
];






// ── Travel inspiration ──────────────────────────────────────────────────
export interface Inspiration {
  title: string;
  image: string;
  blurb: string;
}

export const inspirations: Inspiration[] = [
  { title: 'Best Time to Visit Romania', image: HUB_IMG.chalet2, blurb: 'Late spring and early autumn bring wildflower meadows, golden light and the gentlest crowds.' },
  { title: 'Luxury Experiences Worth Splurging On', image: HUB_IMG.castle, blurb: 'Private castle overnights, helicopter transfers and chef’s-table dinners in noble cellars.' },
  { title: 'Hidden Gems', image: HUB_IMG.farm, blurb: 'The carved-gate villages of Maramureș and the painted monasteries of Bucovina.' },
  { title: 'Photography Locations', image: HUB_IMG.sighisoaraA, blurb: 'Sighișoara’s citadel at dawn, the Transfăgărășan’s switchbacks and delta sunrises.' },
  { title: 'Romantic Getaways', image: HUB_IMG.estate2, blurb: 'Secluded chalets, candlelit castle dinners and horse-cart rides through the meadows.' },
  { title: 'Family Adventures', image: HUB_IMG.deltaResort, blurb: 'Delta boat safaris, the Mocănița steam train and castle treasure hunts.' },
  { title: 'Adventure Travel', image: HUB_IMG.chalet, blurb: 'Carpathian summits, bear watching and the legendary Transfăgărășan drive.' },
  { title: 'Food & Wine Experiences', image: HUB_IMG.estate, blurb: 'Vineyard estates, slow-food farmhouses and Bucharest’s bistronomy revival.' },
];
